jQuery(document).ready(function( $ ) {

    // contact form script
    var $group_tags = $('.wpforms-form .list-of-procedures select').find('option[value="group-start"]');

    $group_tags.each(function(i, e) {
        var label = $(e).text();
        $(e).nextUntil($group_tags).wrapAll('<optgroup label="'+label+'" />');
        $(e).remove();
    });

    // fix for empty elementor columns which only have background image
    // and no content to maintain height on mobile, it add extra class to
    // spacer widget to maintain height on small screens
    $('.elementor-element-populated').each(function() {

        let $count = $(this).find('.elementor-widget-wrap').children('div').length;
        if ( $count < 2 ) {
            if ( $(this).css('background-image') !== 'none' ) {
                $(this).find('.elementor-spacer-inner').addClass('dummy-spacer');
            }
        }
    });

});


// Prevent mousewheel events on IE - fix scrolling issues on IE11 when images have fixed background
(function($) {
    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/12\./)) {
        $('body').on("mousewheel", function () {
            event.preventDefault();
            var wd = event.wheelDelta;
            var csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }
})(jQuery);


